<template>
  <div class="fb-step md-card">
    <md-steppers md-vertical :md-active-step.sync="active">
      <component
        :inStepNavigation="true"
        :key="el.uuid"
        v-for="(el, index) in element.list"
        :uuid="el.uuid"
        :nid="nid"
        :sid="sid"
        :is="el.type"
        :element="el"
        :mode="1"
        :steps="element.list.length"
        :stepIndex="index"
        :active="active"
        :validate-last-step="validate"
        :validate="validate"
        :is-draft="isDraft"
        :pmode="pmode"
        @next-step="nextStep"
        @prev-step="prevStep"
        @set-value="$emit('set-value', $event)"
        @validation="updateValidation(index, $event)"
        @step-done="stepDone(index, $event)"
        @validate-form="$emit('validate-form')"
        @disable-form-validation="$emit('disable-form-validation')"
      ></component>
    </md-steppers>
  </div>
</template>

<script>
import FbElementMixin from "./FbElementMixin";
import FbStep from "./FbStep.vue";

export default {
  name: "FbStepper",
  props: ["element", "validate", "set-view-mode", "go-view-mode", "sid", "nid", "pmode"],
  mixins: [FbElementMixin],
  components: {
    FbStep
  },
  computed: {
    stepTitle() {
      return this.element.list[this.activeIndex].data.label;
    },
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter(el => {
          return el !== true;

        });
        return errors.length == 0;
      }
    }
  },
  created() {

    if (this.element.list[0] && this.element.list[0].uuid) {
      this.active = this.element.list[0].uuid;
    }
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      active: "",
      activeIndex: 0,
      validation: []
    };
  },
  methods: {
    goToStep(stepIndex) {
      this.activeIndex = stepIndex;
      this.active = this.element.list[this.activeIndex].uuid;
    },
    nextStep(currStep) {
      if (currStep < this.element.list.length) {
        this.activeIndex = currStep + 1;
        this.active = this.element.list[this.activeIndex].uuid;
      }
    },
    prevStep(currStep) {
      if (currStep > 0) {
        this.activeIndex = currStep - 1;
        this.active = this.element.list[this.activeIndex].uuid;
      }
    },
    stepDone(currStep) {
      this.nextStep(currStep);
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    }
  },
  watch: {
    element() {
      this.active =
        this.element.list.length > 0 ? this.element.list[0].uuid : "";
    },
    active() {
      this.element.list.map((el, index) => {
        if (el.uuid == this.active) {
          this.activeIndex = index;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.md-steppers.md-vertical {
  .md-steppers-container {
    counter-reset: stepper;
  }

  .md-steppers-wrapper {
    height: auto!important;
  }

  .md-stepper-content.md-active {
    padding-bottom: 0;
  }
  .fb-navigation {
    .md-button.md-button {
      font-size: 14px;
      height: 29px;
      font-weight: 600;
    }
  }

  .md-stepper-number {
    position: relative;
    text-indent: -10000px;

    &::before {
      counter-increment: stepper;
      content: counter(stepper);
      color: #fff!important;
      background-color: transparent;
      position: absolute;
      inset: 0;
      text-indent: 0;
    }
    i.md-icon {
      display: none;
    }

  }

  .md-stepper-text {
    @media (max-width: $breakpoint-mobile) {
      width: 220px;
      white-space: normal;
    }
  }
}
</style>

<style lang="scss" scoped>
.fb-step.md-card {
  position: relative;
  overflow: hidden;
}
</style>
